// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_LnN","cls2":"FocusedNav-cls2_j8E FocusedNav-cls1_LnN","useGrid":"FocusedNav-useGrid_VQ7"};